import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=2f27ba97&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Navbar.vue"
export default component.exports